/* DON'T EDIT THIS FILE: edit original and run build again */ export const onboardingTermsOfUseTitle =
  "BASES Y CONDICIONES GENERALES DE LA CUENTA";
